module.exports = __webpack_public_path__ + "img/icon3.54d3473b.png";